// configs/menuConfig.js
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import PeopleIcon from "@mui/icons-material/People";
import PinDropIcon from "@mui/icons-material/PinDrop";
import DevicesIcon from "@mui/icons-material/Devices";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PolylineIcon from "@mui/icons-material/Polyline";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import EventNoteIcon from "@mui/icons-material/EventNote";

// Tenant bazında menu konfigürasyonları
export const TENANT_MENU_CONFIGS = {
  VAOYS: [
    // {
    //   text: "menu.dashboard",
    //   icon: <HomeRoundedIcon />,
    //   path: "/dashboard",
    // },
    // {
    //   text: "menu.nodeDetail",
    //   icon: <PointOfSaleIcon />,
    //   path: "/vending-machines",
    // },
    // {
    //   text: "menu.regions",
    //   icon: <TravelExploreIcon />,
    //   path: "/regions",
    // },
    // {
    //   text: "menu.vending-definitions", // Varsayılan tenant için - Otomatlar
    //   icon: <PinDropIcon />,
    //   path: "/vending-definitions",
    // },
    // {
    //   text: "menu.users",
    //   icon: <PeopleIcon />,
    //   path: "/users",
    //   requiresAdmin: true,
    // },
    // {
    //   text: "menu.devices",
    //   icon: <DevicesIcon />,
    //   path: "/devices",
    // },
    // {
    //   text: "menu.adminConfigurations",
    //   icon: <AdminPanelSettingsIcon />,
    //   path: "/admin-configurations",
    //   requiresAdmin: true,
    // },
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions",
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.vending-events",
      icon: <EventNoteIcon />,
      path: "/vending-events",
    },
    // {
    //   text: "menu.stocks",
    //   icon: <Inventory2Icon />,
    //   path: "/stock-management",
    // },
    // {
    //   text: "menu.digitalWallet",
    //   icon: <AccountBalanceWalletIcon />,
    //   path: "/digital-wallet",
    // },

    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
    // {
    //   text: "menu.createRoute",
    //   icon: <AltRouteIcon />,
    //   path: "/create-route",
    // },
  ],

  VENDAI: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions",
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.vending-events",
      icon: <EventNoteIcon />,
      path: "/vending-events",
    },
    {
      text: "menu.stocks",
      icon: <Inventory2Icon />,
      path: "/stock-management",
    },
    // {
    //   text: "menu.digitalWallet",
    //   icon: <AccountBalanceWalletIcon />,
    //   path: "/digital-wallet",
    // },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
    // {
    //   text: "menu.createRoute",
    //   icon: <AltRouteIcon />,
    //   path: "/create-route",
    // },
  ],

  WWMS: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.places", // Varsayılan tenant için - Yerler
      icon: <PinDropIcon />,
      path: "/places",
    },
    {
      text: "menu.wwmsdef",
      icon: <PolylineIcon />,
      path: "/node-detail",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  RCU: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      // RCU: "Places" -> /places (live node list / NodeDetail)
      text: "menu.places",
      icon: <PinDropIcon />,
      path: "/places",
    },
    {
      // RCU: "Place Definitions" -> /place-definitions (PlacesDataGrid management)
      text: "menu.wwmsdef",
      icon: <PolylineIcon />,
      path: "/place-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  // Vendai Digital Pay kendi sidebar'ını taşıyor (DigitalPayLayout / NAV_GROUPS).
  // Burada boş: menüyü iki yerde tanımlayıp birbirinden ayrı düşürmeyelim.
  // Boş dizi kasıtlı — [] truthy olduğu için getTenantMenuConfig DEFAULT'a düşmez.
  PERSONAL: [],

  DEFAULT: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions", // Varsayılan tenant için - Otomatlar
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.vending-events",
      icon: <EventNoteIcon />,
      path: "/vending-events",
    },
    {
      text: "menu.stocks",
      icon: <Inventory2Icon />,
      path: "/stock-management",
    },
    // {
    //   text: "menu.digitalWallet",
    //   icon: <AccountBalanceWalletIcon />,
    //   path: "/digital-wallet",
    // },
    {
      text: "menu.createRoute",
      icon: <AltRouteIcon />,
      path: "/create-route",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],
};

/**
 * Get menu configuration for specific tenant
 * @param {string} projectCode - Project code of tenant
 * @returns {Array} Menu items for tenant
 */
export const getTenantMenuConfig = (projectCode) => {
  const items =
    TENANT_MENU_CONFIGS[projectCode] ||
    TENANT_MENU_CONFIGS["DEFAULT"] ||
    TENANT_MENU_CONFIGS["VENDAI"];

  // Hide requiresAdmin menu items for non-admin/non-superAdmin roles
  let isAdmin = false;
  try {
    const raw =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("userRoles")
        : null;
    if (raw) {
      let parsed = raw;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        // If not JSON, treat as plain string
      }

      const adminRoles = ["superAdmin", "admin"];
      const hasAdminRole = (role) => adminRoles.includes(role);

      if (Array.isArray(parsed)) {
        isAdmin =
          parsed.some(hasAdminRole) ||
          parsed.some((r) => hasAdminRole(r?.name) || hasAdminRole(r?.role));
      } else if (typeof parsed === "object" && parsed !== null) {
        const roles = parsed.roles || parsed.userRoles || [];
        if (Array.isArray(roles)) {
          isAdmin =
            roles.some(hasAdminRole) ||
            roles.some((r) => hasAdminRole(r?.name) || hasAdminRole(r?.role));
        }
      } else if (typeof parsed === "string") {
        const tokens = parsed.split(/[\s,;]+/).filter(Boolean);
        isAdmin = tokens.some(hasAdminRole);
      }
    }
  } catch (e) {
    isAdmin = false;
  }

  const userEmail = (() => {
    try {
      return typeof localStorage !== "undefined"
        ? localStorage.getItem("userName") || ""
        : "";
    } catch {
      return "";
    }
  })();

  return items.filter((item) => {
    if (item?.requiresAdmin && !isAdmin) return false;
    if (item?.allowedEmails && !item.allowedEmails.includes(userEmail))
      return false;
    return true;
  });
};
